import BgImage from '../../assets/motor-vehicle/motor-vehicle-bg1.png'
import SMAppInsuranceRenewal from '../../containers/App-MotorVehicle'
import SMAppHomeContactUs from '../../containers/App-Home/ContactUs'
import { Box, Typography } from '@mui/material'
import AppFAQItem from '../../components/ui/AppFAQ'
import axios from 'axios'
import { FAQUrl } from '../../common/url'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'
import { ScreenWidthPort } from '../../ScreenWidthContext'

export const AppMotorVehicleScreen: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()
    
    const { t } = useTranslation()

    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'
    
    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]=' + language + '&filters[category][$eq]=Insurance'
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const renderFaqAccordion = () => (
        <Box sx={{
            width: '100%',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '30px',
            paddingBottom: '30px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF'
        }}>
            <Typography fontSize={24} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingLeft={'16px'} paddingRight={'16px'}>
                {t('t164')}
            </Typography>
            <AppFAQItem data={data}></AppFAQItem>
        </Box>
    )

    // ======================= VIEWS
    return (
        <>
            <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'center',
                width: '100%',
                height: (screenWidth * 226 / 375),
            }}>

                <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <Typography fontSize={32} fontWeight={700} color={'#FBBF23'} textAlign={'center'}>
                        {t('t253')}
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '8px'}}>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t254')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '15px', marginRight: '15px' }}></Box>
                        <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                            {t('t255')}
                        </Typography>
                        <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '15px', marginRight: '0px' }}></Box>

                    </Box>

                    <Typography fontSize={14} fontWeight={400} color={'#FFFFFF'} textAlign={'center'} sx={{marginTop: '5px'}}>
                        {t('t256')}
                    </Typography>
                </Box>
            </Box>

            <SMAppInsuranceRenewal />
            {renderFaqAccordion()}
            <Box sx={{ height: '60px' }}></Box>
            <SMAppHomeContactUs />
        </>
    )
}

// ======================= EXPORT
export default AppMotorVehicleScreen
